import * as React from 'react';
import styles from '../Shared/SubjectDescription.module.css';
import type { HtmlString } from '~/Features/Types/HtmlString.csharp';
import type { DescriptionItemViewModel } from '~/Pages/SubjectInfoPage/DescriptionItemViewModel.csharp';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import { asHtmlString } from '~/Partials/Controls/Utils/asHtmlString';

export interface SubjectInfoDescriptionProps {
    placeholder?: HtmlString;
    manualContent?: HtmlString;
    description?: DescriptionItemViewModel[];
}

export const SubjectInfoDescription: React.FC<SubjectInfoDescriptionProps> = model => {
    const { manualContent, description, placeholder } = model;

    if (manualContent) {
        return <HtmlDiv className={styles.ClearText} html={manualContent} />;
    }

    if (description && description.length > 0) {
        return (
            <>
                {description?.map(paragraph => (
                    <div key={paragraph.heading}>
                        <h3>{paragraph.heading}</h3>
                        {paragraph.body && <HtmlDiv html={paragraph.body} />}
                    </div>
                ))}
            </>
        );
    }

    return <HtmlDiv className={styles.ClearText} html={placeholder ?? asHtmlString('')} />;
};
